module.exports = __webpack_public_path__ + "static/media/400115_02.5b66509c.png";